const notificationsActionTypes = {
  GET_NOTIFICATIONS_START: 'GET_NOTIFICATIONS_START',
  GET_NOTIFICATIONS_SUCCESS: 'GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_FAILURE: 'GET_NOTIFICATIONS_FAILURE',

  READ_NOTIFICATION_START: 'READ_NOTIFICATION_START',
  READ_NOTIFICATION_SUCCESS: 'READ_NOTIFICATION_SUCCESS',
  READ_NOTIFICATION_FAILURE: 'READ_NOTIFICATION_FAILURE',

  READ_ALL_NOTIFICATIONS_START: 'READ_ALL_NOTIFICATIONS_START',
  READ_ALL_NOTIFICATIONS_SUCCESS: 'READ_ALL_NOTIFICATIONS_SUCCESS',
  READ_ALL_NOTIFICATIONS_FAILURE: 'READ_ALL_NOTIFICATIONS_FAILURE',

  GET_UNREAD_NOTIFICATIONS_START: 'GET_UNREAD_NOTIFICATIONS_START',
  GET_UNREAD_NOTIFICATIONS_SUCCESS: 'GET_UNREAD_NOTIFICATIONS_SUCCESS',
  GET_UNREAD_NOTIFICATIONS_FAILURE: 'GET_UNREAD_NOTIFICATIONS_FAILURE',

  ADD_UNREAD_NOTIFICATIONS: 'ADD_UNREAD_NOTIFICATIONS',
};

export default notificationsActionTypes;
